import React from "react";

function Checkbox({ checked, onChange, color = "#3f88a5", disabled = false }) {
  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
      style={{
        width: 16,
        height: 16,
        borderRadius: 4,
        flexShrink: 0,
        border: `1.5px solid ${checked ? (disabled ? "#94a3b8" : color) : "#cbd5e1"}`,
        background: checked ? (disabled ? "#94a3b8" : color) : "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        padding: 0,
        outline: "none",
        fontSize: 10,
        fontWeight: 700,
        color: "#fff",
        transition: "all 0.15s ease",
        boxShadow: checked && !disabled ? `0 1px 3px ${color}44` : "none",
        opacity: disabled ? 0.7 : 1,
      }}
    >
      {checked ? "✓" : null}
    </button>
  );
}

export default Checkbox;
